import arrow from "./imgs/arrow.svg";
import "./index.scss";

const GoToTopWrap = (props) => {
  const { custName } = props;
  return (
    <div className="goToTopWrap" style={custName}>
      {/* <div className="infoContent"> */}
      <div
        className="gotoBtn"
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <span>Go to top</span>
        <img src={arrow} alt="" />
      </div>
      <div className="hintText">©2023 Swiss Blockchain Labs</div>
      {/* </div> */}
    </div>
  );
};

export default GoToTopWrap;
